import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES } from 'animations/Animations';
import { Column } from 'hedron';
import { Column as ColumnModel } from 'models';
import HTMLParser from 'blocks/Parser/Parser';

const ColumnBlock = ({ data, lgShift, id }) => (
  <Column
    lg={5}
    lgShift={lgShift}
  >
    <Fade
      bottom
      distance={`${FADE_VALUES.TEXT.LARGE}`}
      delay={FADE_VALUES.DELAY.SMALL * id}
    >
      <HTMLParser
        htmlModifiers={data.htmlModifiers}
        htmlBody={data.content}
      />
    </Fade>
  </Column>
);
ColumnBlock.propTypes = {
  data: PropTypes.instanceOf(ColumnModel).isRequired,
  lgShift: PropTypes.number,
  id: PropTypes.number,
};
ColumnBlock.defaultProps = {
  lgShift: 0,
  id: 0,
};
export default ColumnBlock;



// WEBPACK FOOTER //
// ./src/kentico-blocks/TwoColumnGrid/Column.jsx